/**
 * Fitness Bioforce — Main JavaScript (Shopify Version)
 */
(function () {
    'use strict';

    /* ==============================
       MOBILE MENU TOGGLE
       ============================== */
    const toggle = document.querySelector('.mobile-toggle');
    const mainNav = document.getElementById('main-nav');

    if (toggle && mainNav) {
        toggle.addEventListener('click', function () {
            const expanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!expanded));
            this.classList.toggle('active');
            mainNav.classList.toggle('active');
            document.body.style.overflow = mainNav.classList.contains('active') ? 'hidden' : '';
        });

        mainNav.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                toggle.classList.remove('active');
                toggle.setAttribute('aria-expanded', 'false');
                mainNav.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }

    /* ==============================
       HEADER SCROLL EFFECT
       ============================== */
    const header = document.querySelector('.site-header');

    if (header) {
        window.addEventListener('scroll', function () {
            var scrollY = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollY > 60) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }, { passive: true });
    }

    /* ==============================
       SMOOTH SCROLL (Anchor Links)
       ============================== */
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            var targetId = this.getAttribute('href');
            if (targetId === '#' || targetId.length < 2) return;
            var target = document.querySelector(targetId);
            if (target) {
                e.preventDefault();
                var offset = header ? header.offsetHeight + 16 : 80;
                var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        });
    });

    /* ==============================
       INTERSECTION OBSERVER — Reveal
       ============================== */
    var revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');

    if (revealElements.length > 0 && 'IntersectionObserver' in window) {
        var revealObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    revealObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.12,
            rootMargin: '0px 0px -40px 0px'
        });

        revealElements.forEach(function (el) {
            revealObserver.observe(el);
        });
    } else {
        revealElements.forEach(function (el) {
            el.classList.add('visible');
        });
    }

    /* ==============================
       SCROLL TO TOP BUTTON
       ============================== */
    var scrollToTopBtn = document.getElementById('scrollToTop');
    if (scrollToTopBtn) {
        window.addEventListener('scroll', function () {
            if (window.pageYOffset > 600) {
                scrollToTopBtn.classList.add('visible');
            } else {
                scrollToTopBtn.classList.remove('visible');
            }
        }, { passive: true });

        scrollToTopBtn.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    /* ==============================
       FAQ ACCORDION
       ============================== */
    document.querySelectorAll('.faq-question').forEach(function(btn){
        btn.addEventListener('click', function(){
            var item = this.closest('.faq-item');
            var isOpen = item.classList.contains('active');
            
            // Close all in same category
            item.closest('.faq-list').querySelectorAll('.faq-item.active').forEach(function(open){
                open.classList.remove('active');
                open.querySelector('.faq-question').setAttribute('aria-expanded','false');
            });
            
            if(!isOpen){
                item.classList.add('active');
                this.setAttribute('aria-expanded','true');
            }
        });
    });

    /* ==============================
       CATEGORY FILTER (Supplements Page)
       ============================== */
    const filterBtns = document.querySelectorAll('.cat-filter-btn');
    const productCards = document.querySelectorAll('.supp-card');
    const resultCount = document.getElementById('supp-result-count');
    const emptyState = document.getElementById('supp-empty-state');
    const grid = document.getElementById('supp-products-grid');
    
    if (filterBtns.length > 0) {
        filterBtns.forEach(function(btn){
            btn.addEventListener('click', function(){
                filterBtns.forEach(function(b){ b.classList.remove('active'); });
                btn.classList.add('active');
                const filter = btn.getAttribute('data-filter');
                
                let visibleCount = 0;
                productCards.forEach(function(card, index){
                    if (filter === 'all' || card.getAttribute('data-category') === filter) {
                        card.style.display = '';
                        card.style.opacity = '0';
                        card.style.transform = 'translateY(16px)';
                        setTimeout(function(){
                            card.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
                            card.style.opacity = '1';
                            card.style.transform = 'translateY(0)';
                        }, visibleCount * 50);
                        visibleCount++;
                    } else {
                        card.style.display = 'none';
                    }
                });

                // Update count
                if (resultCount) {
                    resultCount.innerHTML = 'Showing <strong>' + visibleCount + '</strong> product' + (visibleCount !== 1 ? 's' : '');
                }

                // Empty state
                if (emptyState) {
                    emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
                }
                if (grid) {
                    grid.style.display = visibleCount === 0 ? 'none' : '';
                }
            });
        });
    }

    /* ==============================
       TOAST NOTIFICATION
       ============================== */
    function showToast(message, type) {
        type = type || 'success';
        var existing = document.querySelector('.fb-toast');
        if (existing) existing.remove();

        var toast = document.createElement('div');
        toast.className = 'fb-toast fb-toast--' + type;
        toast.innerHTML = '<span class="fb-toast-icon">' +
            (type === 'success' ? '&#10003;' : '&#9432;') +
            '</span><span class="fb-toast-msg">' + message + '</span>';
        document.body.appendChild(toast);

        requestAnimationFrame(function () {
            toast.classList.add('fb-toast--visible');
        });

        setTimeout(function () {
            toast.classList.remove('fb-toast--visible');
            setTimeout(function () { toast.remove(); }, 350);
        }, 3000);
    }

    /* ==============================
       ADD TO CART FEEDBACK
       ============================== */
    document.addEventListener('submit', function(e) {
        const form = e.target;
        if (form.matches('form[action*="/cart/add"]')) {
            const btn = form.querySelector('button[type="submit"]');
            if (btn) {
                const originalText = btn.textContent;
                btn.classList.add('btn-loading');
                btn.innerHTML = '<span class="btn-spinner"></span>';
                
                setTimeout(function() {
                    btn.classList.remove('btn-loading');
                    btn.textContent = originalText;
                }, 800);
            }
        }
    });

    console.log('✅ Fitness Bioforce Theme Loaded');

})();
